import { MdOutlineDelete, MdOutlineEdit } from 'react-icons/md';
import { MenuItemType } from '@ui';

type ActionsConfig = {
  key: string;
  to: string;
  onAction: () => void;
};

type EditDeleteActionsConfig = {
  editConfig: ActionsConfig;
  deleteConfig: ActionsConfig;
};

export const buildEditDeleteActionsMenu = ({ editConfig, deleteConfig }: EditDeleteActionsConfig): MenuItemType[] => [
  {
    key: editConfig.key,
    type: 'action',
    to: editConfig.to,
    label: (
      <div className="flex items-center gap-2">
        <MdOutlineEdit size={16} />
        <span className="text-m-r">Edit</span>
      </div>
    ),
    onAction: editConfig.onAction,
  },
  {
    key: deleteConfig.key,
    type: 'action',
    to: deleteConfig.to,
    label: (
      <div className="flex items-center gap-2 text-danger">
        <MdOutlineDelete size={16} />
        <span className="text-m-r">Delete</span>
      </div>
    ),
    onAction: deleteConfig.onAction,
  },
];
